import './styles.scss'
import React from 'react'

import { Button } from 'components/Form'

const SimpleBanner = ({ className, title, subtitle, buttonText, buttonAction, isSubmitting, isFloating }) => (
  <div className={`simple-banner ${className ? className : ''} ${isFloating ? 'simple-banner--floating' : ''}`}>
    <div className='simple-banner__content'>
      <p className='simple-banner__title'>{title}</p>
      <p className='simple-banner__subtitle'>{subtitle}</p>
    </div>
    <Button
      secondary
      value={buttonText}
      onClick={buttonAction}
      isSubmitting={isSubmitting}
    />
  </div>
)

export default SimpleBanner
